import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.css'],
})
export class BlogListComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'blogName',
    'viewedCount',
    'createdDate',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private listApi = environment.url + environment.blogList;
  private deleteApi = environment.url + environment.blogDelete;
  /**
   * Constructor for the BlogListComponent.
   * Initializes the component with the necessary services.
   * @param router The router service for navigating to other routes.
   * @param makeapi The API service for making API calls.
   * @param getdata The value service for managing application values.
   * @param notify The notify service for sending notifications.
   * @param dialog The dialog service for opening dialogs.
   */
  constructor(
    private router: Router,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    // Initialize the MatTableDataSource
    this.dataSource = new MatTableDataSource();
  }
  roleValue;
  /**
   * Initializes the component.
   * Sets the visible flag in the ValueService to true.
   * Retrieves the role from the session storage and assigns it to the roleValue.
   * Calls the eventList method to fetch the list of blogs.
   */
  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
    // Get the role from the session storage
    this.roleValue = sessionStorage.getItem('role');
    // Fetch the list of blogs
    this.eventList();
  }
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 10;
  pageNumber: number = 1;
  noData = true;
  /**
   * Fetches the list of blogs from the API based on the pagination.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  eventList() {
    // Create the API request parameters
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };

    // Call the API to fetch the list of blogs
    this.ListApi();
  }
  /**
   * Fetches the list of blogs from the API.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  ListApi() {
    // Fetch the list of blogs from the API
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data) => {
        // Check if the response contains any data
        if (data.count == 0) {
          // If no data, show the "No Data" message
          this.noData = true;
        } else {
          // If data is present, hide the "No Data" message
          this.noData = false;
          // Update the page total count
          this.pageTotalCount = data.count;
          // Update the list of blogs
          this.disList = data.responsemodelList;
          // Update the MatTableDataSource
          this.dataSource = new MatTableDataSource(data.responsemodelList);
        }
      });
  }
  /**
   * Initializes the paginator after the component view has been initialized.
   * Called after the component's view has been fully initialized.
   * Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    // Set the paginator for the MatTableDataSource
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Handles the pagination event.
   * Updates the page number and page size based on the pagination event.
   * @param event The pagination event containing the page index and page size.
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;

    // Create the request parameters for the API call
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };

    // Call the API to fetch the updated data
    this.ListApi();
  }

  /**
   * Navigates to the add blog page.
   */
  addBlog() {
    // Navigate to the add blog page
    this.router.navigateByUrl('/admin/blog/add');
  }
  /**
   * Redirects to the blog edit page with the specified blog ID.
   * @param id - The ID of the blog to be edited.
   */
  editBlog(id) {
    // Encode the blog ID and navigate to the edit page
    this.getdata.blogId(btoa(id));
  }
  /**
   * Deletes a blog by its ID.
   * @param id - The ID of the blog to be deleted.
   * @returns A subscription to the delete API call.
   */
  deleteBlog(id) {
    // Make an API call to delete the blog with the specified ID
    return this.makeapi
      .method(this.deleteApi + id, '', 'delete')
      .subscribe((data) => {
        // Check if the response status is 'Success'
        if (data.responseStatus == 'Success') {
          // Notify the user of the successful deletion
          this.notify.notifysuccess(data.responseMessage);
          // Refresh the event list to reflect the deletion
          this.eventList();
        } else {
          // Notify the user of an error during deletion
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
}
